import { FC, SVGAttributes } from 'react';

const StateFatal: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0191 4.01325C10.8691 2.43569 13.1316 2.43569 13.9816 4.01325L21.9701 18.8493C22.1546 19.1921 22.2471 19.5769 22.2384 19.966C22.2298 20.3552 22.1203 20.7354 21.9207 21.0696C21.7211 21.4038 21.4383 21.6805 21.0997 21.8727C20.7612 22.0649 20.3786 22.1659 19.9894 22.166H4.01145C3.62219 22.1659 3.23947 22.0649 2.90095 21.8727C2.56243 21.6805 2.27956 21.4038 2.07998 21.0696C1.88039 20.7354 1.77093 20.3552 1.76227 19.966C1.75362 19.5769 1.84608 19.1921 2.03061 18.8494L10.0191 4.01325ZM12.0041 7.74316C11.2469 7.74316 10.6552 8.39697 10.7306 9.15043L11.2266 13.7964C11.2666 14.1958 11.6027 14.5 12.0041 14.5C12.4056 14.5 12.7417 14.1958 12.7816 13.7964L13.2777 9.15043C13.353 8.39697 12.7614 7.74316 12.0041 7.74316ZM12.0041 16.2289C11.223 16.2289 10.5898 16.8621 10.5898 17.6432C10.5898 18.4243 11.223 19.0574 12.0041 19.0574C12.7852 19.0574 13.4184 18.4243 13.4184 17.6432C13.4184 16.8621 12.7852 16.2289 12.0041 16.2289Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StateFatal;
